/* eslint-disable */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';

import BrandHeader from './header/brand-header';

import LocaleSelectorConnector from '../../containers/locale-selector-connector';
import SearchFormConnector from '../../containers/search-form-connector';
import UserMenuConnector from '../../containers/user-menu-connector';
import UserMobilMenuConnector from '../../containers/user-mobil-menu-connector';

import APP_ROUTES from '../../constants/app-routes';

import styles from './styles/header.scss';
import MobileMenuConnector from '../../containers/menus/mobile-menu-connector';
import history from '../../browser-history';
import DesktopMenu from './header/desktop-menu';
import StoreAPI from '../../apis/store';
import ZoneModal from '../zone/zone-modal';
import HeaderMenuConnector from '../../containers/menus/header-menu-connector';
import TimeParse from '../../services/time-parse';

import KtpOffCanvas from './ktp-off-canvas';
import SecondaryMenuConnector from '../../containers/menus/secondary-menu-connector';
import spreeStore from '../../store';
import actions from '../../actions';
import ZoneService from "../../services/zone-service";
import APP_DEFAULTS from '../../constants/app-defaults';
import MunicipalityService from '../../services/municipality-service';
import MunicipalitySelectorModal from './municipality-selector-modal';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showLanguageList: false,
            showMobileMenu: false,
            menu: [],
            showZoneModal: false,
            selectedZoneId: undefined,
            pendingPath: undefined,
            selectStored: undefined,
            showMobileFilter: false,
            showMunicipalitySelector: false,
            selectedZoneMunicipalities: [],
            paramsToContinue: {},
        };

        this.toggleLanguageList = this.toggleLanguageList.bind(this);
        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
        this.toggleFirstMenu = this.toggleFirstMenu.bind(this);
        this.toggleSecondMenu = this.toggleSecondMenu.bind(this);
        this.buildMenu = this.buildMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.handleClickOnStoreAndZone = this.handleClickOnStoreAndZone.bind(this);
        this.handleCloseZoneModal = this.handleCloseZoneModal.bind(this);
        this.toggleMobileFilter = this.toggleMobileFilter.bind(this);
    }

    componentWillMount() {
        this.unlisten = history.listen((location, action) => {
            this.setState({ showMobileMenu: false, showLanguageList: false });
        });
    }

    componentDidMount() {
        const params = this.getParamsFormURL();
        if(params['zone_id']) {
            this.props.setCurrentZone(parseInt(params['zone_id'], 10));
        }
        this.props.loadGroupedStores().then((groupedStores) => {
            this.buildMenu(groupedStores.zones, groupedStores.data, this.props.currentZone, this.props.multiCountryShipping);
        });
    }

    /* shouldComponentUpdate(nextProps, nextState) {
        const params = this.getParamsFormURL();
        const state = spreeStore.getState();
        let updateRequired = false;
        if (params['zone_id'] && state.zones && state.zones.currentZone && parseInt(params['zone_id'], 10) !== state.zones.currentZone) {
            this.props.setCurrentZone(parseInt(params['zone_id'], 10));
            updateRequired = true;
        }
        return updateRequired || JSON.stringify(nextProps) !== JSON.stringify(nextState);
    } */

    componentDidUpdate(prevProps, prevState) {
        const prevZones = prevProps.stores.storesGrouped.zones || [];
        const prevStores = prevProps.stores.storesGrouped.data || {};
        const currentZones = this.props.stores.storesGrouped.zones || [];
        const currentStores = this.props.stores.storesGrouped.data || {};
        const currentStore = this.props.stores.currentStore || {};

        if (currentZones.length > 0 && Object.keys(currentStores).length > 0
            && Object.keys(currentStore).length > 0
            && (prevProps.locale.currentLocale !== this.props.locale.currentLocale
            || (prevProps.currentZone !== this.props.currentZone && this.props.multiCountryShipping)
            || (prevZones !== currentZones && this.props.multiCountryShipping)
            || (prevStores !== currentStores && this.props.multiCountryShipping)
            || (prevProps.stores.currentStore.id !== currentStore.id)
            || prevProps.multiCountryShipping !== this.props.multiCountryShipping)) {
            this.buildMenu(currentZones, currentStores, this.props.currentZone, this.props.multiCountryShipping);
        }
    }

    componentWillUnmount() {
        this.unlisten();
    }

    getParamsFormURL = () => {
        const query = new URLSearchParams(this.props.location.search);
        const params = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const [param0, param1] of query.entries()) {
            params[param0] = param1;
        }
        return params;
    }

    buildMenu(zones, stores, currentZone, multiStore) {
        if (zones.length > 0 && Object.keys(stores).length > 0) {
            const tmpMenu = [{
                label: this.props.stores.currentStore.name,
                id: this.props.stores.currentStore.id,
                type: 'link',
            },
            {
                label: multiStore
                    ? ZoneService.getNameCurrentZone(zones, currentZone)
                    : this.props.intl.formatMessage({ id: 'for-cuba' }),
                id: 2,
                type: 'first_level',
                items: zones.map((zone) => {
                    const zoneTmp = {
                        type: 'second_level',
                        label: zone.name,
                        id: zone.id,
                        items: [],
                    };

                    if (stores[zone.id]) {
                        zoneTmp.items = stores[zone.id].map((item) => {
                            const store = {
                                id: item.id,
                                label: item.name,
                            };
                            return store;
                        });
                    }

                    return zoneTmp;
                }),
            }];

            this.setState((prevState) => ({ menu: tmpMenu }));
        }
    }

    toggleMobileMenu() {
        const componentId = 'HEADER';
        this.setState((prevState) => ({ showMobileMenu: !prevState.showMobileMenu }), () => {
            const rootElem = document.getElementById('root');
            if (this.state.showMobileMenu) {
                rootElem.classList.add('disabled');
                spreeStore.dispatch(actions.setBackgroundDisabled({
                    triggedBy: componentId,
                }));
            } else if (spreeStore.getState().backgroundDisabled.triggedBy === componentId) {
                rootElem.classList.remove('disabled');
                spreeStore.dispatch(actions.setBackgroundDisabled({
                    triggedBy: null,
                }));
            }
        });
    }

    toggleLanguageList() {
        this.setState((prevState) => ({ showLanguageList: !prevState.showLanguageList }));
    }

    // eslint-disable-next-line class-methods-use-this
    handleClickOnStoreAndZone(zoneId, storeId) {
        if(zoneId === undefined) {
            zoneId = this.props.currentZone
        }

        const storesInZone = this.props.stores.storesGrouped.data && this.props.stores.storesGrouped.data[zoneId] ? this.props.stores.storesGrouped.data[zoneId] : [];
        if (!storesInZone.find((store) => store.id === storeId)) {
            if (storesInZone.length > 0) {
                storeId = storesInZone[0].id;
            }
        }
        const selectStored = this.props.stores.stores.find((store) => store.id === storeId);
        this.closeMenu();
        const to = `/${selectStored.code}${zoneId ? `?zone_id=${zoneId}` : ''}`;

        if (zoneId !== undefined && this.props.currentZone !== zoneId && this.props.order.line_items.length > 0) {
            this.setState((state) => ({
                selectedZoneId: zoneId, pendingPath: to, showZoneModal: true, selectStored,
            }));
        } else {
            const { zones: { availableZones }, municipalities: { availableMunicipalities, currentMunicipality }} = spreeStore.getState();
            const selectedZoneMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(zoneId, availableZones, availableMunicipalities);
            if (MunicipalityService.isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities)) {
                this.setState((state) => ({
                    showMunicipalitySelector: true,
                    selectedZoneMunicipalities,
                    paramsToContinue: { zoneId, storeId },
                }));
            } else {
                this.props.setCurrentStore(selectStored);
                if (zoneId !== undefined) {
                    this.props.setCurrentZone(zoneId);
                }
                this.props.history.push(to);
            }
        }
    }

    handleCloseZoneModal(clean) {
        if (clean) {
            this.props.emptyCart(this.props.order, this.props.locale.currentLocale)
                .then(() => {
                    this.props.setCurrentZone(this.state.selectedZoneId);
                    this.props.setCurrentStore(this.state.selectStored);
                    this.props.history.push(this.state.pendingPath);
                })
                .catch((err) => console.log(err));
        }
        this.setState({ showZoneModal: false });
    }

    closeMenu() {
        const tmpMenu = [...this.state.menu];

        tmpMenu.forEach((item) => {
            item.open = false;
            if (item.items) {
                item.items.forEach((subitem) => {
                    subitem.open = false;
                });
            }
        });
        this.setState((prevState) => ({ menu: tmpMenu }));
    }

    toggleFirstMenu(parentId) {
        const tmpMenu = [...this.state.menu];

        tmpMenu.forEach((item) => {
            if (item.id === parentId) {
                item.open = !item.open;
            } else {
                item.open = false;
            }
        });
        this.setState((prevState) => ({ menu: tmpMenu }));
    }

    toggleSecondMenu(parentId, childId) {
        const tmpMenu = [...this.state.menu];

        tmpMenu.forEach((item) => {
            if (item.id === parentId) {
                item.items.forEach((subittem) => {
                    if (subittem.id === childId) {
                        subittem.open = !subittem.open;
                    } else {
                        subittem.open = false;
                    }
                });
            }
        });
        this.setState((prevState) => ({ menu: tmpMenu }));
    }

    toggleMobileFilter() {
        this.setState((prevState) => ({ ...prevState, showMobileFilter: !prevState.showMobileFilter }));
    }

    handleSelectedMunicipality(municipality) {
        spreeStore.dispatch(actions.setCurrentMunicipality(municipality.id));
        const { zoneId, storeId } = this.state.paramsToContinue;
        this.handleClickOnStoreAndZone(zoneId, storeId);
        this.setState({
            showMunicipalitySelector: false,
            paramsToContinue: {},
        });
    }

    getCurrentMunicipality() {
        const { municipalities: { availableMunicipalities = [] } } = spreeStore.getState();
        return availableMunicipalities && availableMunicipalities.find && availableMunicipalities.find((mun) => mun.id === this.props.currentMunicipality);
    }

    render() {
        const userLoggedInClass = this.props.user && this.props.user.id ? 'user-logged-in ' : 'guest-user ';
        const isLogging = this.props.user && this.props.user.id;
        return (
            <nav className={`global-header navbar ${userLoggedInClass}${styles.header}`}>

                <MobileMenuConnector
                    showMobileMenu={this.state.showMobileMenu}
                    toggleMobileMenu={this.toggleMobileMenu}
                    menu={this.state.menu}
                    toggleFirstMenu={this.toggleFirstMenu}
                    toggleSecondMenu={this.toggleSecondMenu}
                    closeMenu={this.closeMenu}
                    setCurrentZone={this.props.setCurrentZone}
                    setCurrentStore={this.props.setCurrentStore}
                    handleClickOnStoreAndZone={this.handleClickOnStoreAndZone}
                />
                <div style={{ height: '70px' }}>
                    <div className="container">
                        <div className="row">
                            <div className={`col-md-4 col-sm-12 col-xs-12 ${styles.headerNavbarCol}`}>
                                <div className={styles.headerNavbar}>
                                    <button type="button" className={`navbar-toggle navbar-toggle-left ${styles.navbarToggle}`} onClick={this.toggleMobileMenu}>
                                        <span className={styles.srOnly}>Toggle navigation</span>
                                        <span className={styles.iconBar} />
                                        <span className={styles.iconBar} />
                                        <span className={styles.iconBar} />
                                    </button>
                                    <BrandHeader />
                                    {/* Solo para version Mobil */}
                                    <Link to={APP_ROUTES.cartPageRoute} className={`link-xs hidden-md hidden-lg pull-right ${styles.addToCartMobile}`}>
                                        <FormattedMessage id="cart" defaultMessage="Cart" />
                                        <i className={`pe-7f-cart pe-lg pe-va ${styles.cartIcon}`} />
                                        {this.props.order.item_count && (
                                            <i className={`${styles.badge} ${this.props.cartState.lastAlert ? styles.timeCartLastAlert : ''}`}>
                                                {this.props.order.item_count}
                                            </i>
                                        )}
                                        {this.props.order.item_count > 0 && (
                                            <span className={`hidden-md hidden-lg pull-right ${styles.timeCartLeftMobile}`}>
                                                {TimeParse.fromSeconds(this.props.cartState.timeSecondsLeft)}
                                            </span>
                                        )}
                                    </Link>
                                    <UserMobilMenuConnector />
                                    <div style={{ clear: 'both' }} />
                                </div>
                            </div>
                            {/* Menu para Desktop */}
                            <div className={`col-md-8 col-xs-12 ${styles.icons} hidden-xs hidden-sm`} style={{ marginTop: 15 }}>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <ul className={`nav navbar-nav navbar-right navbar-medium ${styles.navbarRight}`}>
                                            {/* {this.navIcons()} */}
                                            {isLogging && (<UserMenuConnector />)}

                                            {!isLogging && process.env.REACT_APP_DISABLE_AUTH !== 'true' && (
                                                <li>
                                                    <Link to={APP_ROUTES.signin} className={`${styles.linkOrange}`}>
                                                        <FormattedMessage id="signin" defaultMessage="Sign In" />
                                                    </Link>
                                                </li>
                                            )}

                                            {/* {!isLogging && ( */}
                                            {/*    <li id="classified" className={`dropdown ${styles.classified}`}> */}
                                            {/*        <Link to={APP_ROUTES.classifiedAds} className={`${styles.linkOrange}`}> */}
                                            {/*            <FormattedMessage id="classified-ads" defaultMessage="Classified Ads" /> */}
                                            {/*        </Link> */}
                                            {/*    </li> */}
                                            {/* )} */}

                                            <li style={{ display: 'none' }}>
                                                {/* TODO: Remove display option to show wishlist button */}
                                                <Link to={APP_ROUTES.wishList}>
                                                    <i className="pe-7f-like pe-lg pe-va margin-left-10" />
                                                    <i
                                                        className="badge"
                                                        style={{
                                                            marginBottom: '12px',
                                                            backgroundColor: '#d3af71',
                                                        }}
                                                    />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={APP_ROUTES.cartPageRoute}>
                                                    <i className={`pe-7f-cart pe-lg pe-va margin-left-10 ${styles.cartIcon}`} />
                                                    <i
                                                        className={`badge ${this.props.cartState.lastAlert ? styles.timeCartLastAlert : ''}`}
                                                        style={{
                                                            marginBottom: '12px',
                                                            backgroundColor: APP_DEFAULTS.theme.cartBadgeBackgroundColor,
                                                        }}
                                                    >
                                                        {this.props.order.item_count}
                                                    </i>
                                                    {this.props.order.item_count > 0 && (
                                                        <div className={styles.timeCartLeftDesktop}>
                                                            <span>
                                                                {TimeParse.fromSeconds(this.props.cartState.timeSecondsLeft)}
                                                            </span>
                                                        </div>
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <LocaleSelectorConnector />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.headerSecondRow}`}>
                    <div className="container">
                        <div className="" style={{ flexDirection: 'row' }}>
                            <div className={`hidden-xs hidden-sm ${styles.menuDesktopContainer}`}>
                                <DesktopMenu
                                    menu={this.state.menu}
                                    currentMunicipality={this.getCurrentMunicipality()}
                                    toggleFirstMenu={this.toggleFirstMenu}
                                    toggleSecondMenu={this.toggleSecondMenu}
                                    closeMenu={this.closeMenu}
                                    handleClickOnStoreAndZone={this.handleClickOnStoreAndZone}
                                />
                            </div>
                            <div className="" style={{ display: 'flex' }}>
                                <div className={styles.searchContainer}>
                                    <SearchFormConnector />
                                </div>
                                <div className={styles.filter} onClick={this.toggleMobileFilter}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={APP_DEFAULTS.theme.cartFillColor} className="bi bi-funnel-fill" viewBox="0 0 16 16">
                                        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ZoneModal
                    show={this.state.showZoneModal}
                    onHide={this.handleCloseZoneModal}
                />
                <MunicipalitySelectorModal
                    isOpen={this.state.showMunicipalitySelector}
                    currentZoneMunicipalities={this.state.selectedZoneMunicipalities}
                    handleClose={(municipality) => this.handleSelectedMunicipality(municipality)}
                />
                <KtpOffCanvas isOpen={this.state.showMobileFilter} onClose={() => { this.toggleMobileFilter() }}>
                    <SecondaryMenuConnector location={this.props.location} path={APP_ROUTES.searchPageRoute} />
                </KtpOffCanvas>
                <HeaderMenuConnector />
            </nav>
        );
    }
}

export default withRouter(injectIntl(Header));



/** WEBPACK FOOTER **
 ** ./src/components/shared/header.jsx
 **/